export default __webpack_public_path__ + "static/media/lodgify_step11.80d1a239.jpg";